import { render, staticRenderFns } from "./add-invoice.vue?vue&type=template&id=c5e41902&scoped=true&"
import script from "./add-invoice.vue?vue&type=script&lang=js&"
export * from "./add-invoice.vue?vue&type=script&lang=js&"
import style0 from "./add-invoice.vue?vue&type=style&index=0&id=c5e41902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e41902",
  null
  
)

export default component.exports